import { Injector, Type } from '@angular/core';

import { mergeAttributes, Node as TipTapNode } from '@tiptap/core';
import { AngularNodeViewComponent, AngularNodeViewRenderer } from 'ngx-tiptap';

import { APP_TIPTAP_EDITOR_RENDER_AS } from '../tokens';

export type EmailFormAnswersOptions = {
    HTMLAttributes: Record<string, any>;
};
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        emailFormAnswers: {
            insertEmailFormAnswers: () => ReturnType;

            updateEmailFormAnswers: () => ReturnType;
        };
    }
}

export const createEmailFormAnswersExtension = (injector: Injector, component: Type<AngularNodeViewComponent>) => {
    const renderAs = injector.get(APP_TIPTAP_EDITOR_RENDER_AS);

    return TipTapNode.create<EmailFormAnswersOptions>({
        name: 'emailFormAnswers',
        inline: false,
        group: 'block',
        selectable: true,
        draggable: true,
        atom: true,

        addOptions() {
            return {
                HTMLAttributes: {},
            };
        },

        addAttributes() {
            return {
                variable: {
                    default: '',
                },
                options: undefined,
            };
        },

        parseHTML() {
            return [{ tag: `[data-type="${this.name}"]` }];
        },

        renderHTML({ node, HTMLAttributes }) {
            if (renderAs === 'html') {
                return [
                    'div',
                    mergeAttributes(this.options.HTMLAttributes, {
                        // ...HTMLAttributes,
                        options: HTMLAttributes['options'] || undefined,

                        style: HTMLAttributes['style'],
                        'data-type': this.name,
                    }),
                ];
            }

            return [
                'div',
                mergeAttributes(this.options.HTMLAttributes, {
                    style: HTMLAttributes['style'],
                }),
                '{% if formAnswers %}',
                '{% for response in formAnswers %}',
                ['dl', {}, ['dt', {}, '{{ response.Question }}'], ['dd', {}, '{{ response.Answer }}']],
                '{% endfor %}',
                '{% endif %}',
            ];
        },

        addNodeView() {
            return AngularNodeViewRenderer(component, { injector });
        },

        addCommands() {
            return {
                insertEmailFormAnswers:
                    () =>
                    ({ tr, dispatch, editor }) => {
                        const { selection } = tr;
                        const node = this.type.create();

                        if (dispatch) {
                            tr.replaceRangeWith(selection.from, selection.to, node);
                        }

                        return true;
                    },

                updateEmailFormAnswers:
                    () =>
                    ({ chain, tr }) => {
                        const config: Record<string, string> = {};
                        const node = (tr as any).curSelection?.node;

                        if (!node || node.type.name !== this.name) {
                            return false;
                        }

                        return chain().updateAttributes(this.name, config).run();
                    },
            };
        },
    });
};
